
import { Component, Vue } from 'vue-property-decorator';
import BusinessUnitService from '../domain/businessUnit/BusinessUnitService';

@Component
export default class Navgation extends Vue {
  drawer = false;

  permanent = null;

  businessUnitNames: string[] = [];

  darkmode = localStorage.getItem('darkmode') === 'true';

  async created() {
    this.businessUnitNames = await BusinessUnitService.getBusinessUnitNames();
  }

  setDarkMode() {
    if (this.darkmode) {
      localStorage.setItem('darkmode', 'true');
      this.$vuetify.theme.dark = true;
    } else {
      localStorage.removeItem('darkmode');
      this.$vuetify.theme.dark = false;
    }
    this.$store.commit('darkmodeRerender');
  }
}
